var _window$liquidAjaxCar;
var detailsCheck = false;

// Product variant ID to event suffix mapping
const PRODUCT_EVENT_SUFFIXES = {
  '52523787256124': '_free',            // Free - Kiwi Driver (layout/kiwi-driver.liquid)
  '52523787321660': '_package',         // $49 - Existing AMI customers (YES)
  '52523787354428': '_premier_package'  // $79 - New customers (NO)
};

// KiwiDriver variant ID (only product that fires Floodlight)
const KIWI_DRIVER_VARIANT_ID = '52523787256124';

/**
 * Get product event suffix based on selected product variant
 * @param {HTMLElement} flowForm - The flow form element
 * @returns {string} Event suffix (e.g., '_free', '_package', '_premier_package')
 */
function getProductEventSuffix(flowForm) {
  const selectedRadio = flowForm.querySelector('input[name="existing-customer"]:checked');
  if (selectedRadio && selectedRadio.dataset.product) {
    return PRODUCT_EVENT_SUFFIXES[selectedRadio.dataset.product] || '';
  }
  return '';
}

/**
 * Check if the selected product is KiwiDriver (Free)
 * @param {HTMLElement} flowForm - The flow form element
 * @returns {boolean} True if KiwiDriver product is selected
 */
function isKiwiDriverProduct(flowForm) {
  const selectedRadio = flowForm.querySelector('input[name="existing-customer"]:checked');
  return selectedRadio && selectedRadio.dataset.product === KIWI_DRIVER_VARIANT_ID;
}

/**
 * Fire tracking event to dataLayer, Google Floodlight, and Meta Pixel
 * @param {string} eventName - The event name to push
 * @param {string} floodlightActivityId - Optional Floodlight Activity ID for conversion tracking
 * @param {object} metaEventData - Optional Meta Pixel event data { eventName: 'Lead', params: {} }
 */
function fireTrackingEvent(eventName, floodlightActivityId, metaEventData) {
  try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') { window.Shopify.analytics.publish(eventName, { step_event: eventName }); } } catch (e) {}
  window.dataLayer = window.dataLayer || [];
  
  // Push to dataLayer for GTM
  window.dataLayer.push({ event: eventName });
  
  // Fire Google Floodlight conversion if Activity ID provided
  if (floodlightActivityId && typeof gtag === 'function') {
    gtag('event', 'conversion', {
      'send_to': 'DC-8062289/' + floodlightActivityId,
      'value': 0,
      'currency': 'NZD'
    });
  }
  
  // Fire Meta Pixel event if provided and fbq is available
  if (metaEventData && typeof fbq === 'function') {
    fbq('track', metaEventData.eventName, metaEventData.params || {});
    // console.log('[AMI Tracking] Meta Pixel:', metaEventData.eventName, metaEventData.params || {});
  }
  
  // console.log('[AMI Tracking] Event fired:', eventName, floodlightActivityId ? '(Floodlight: ' + floodlightActivityId + ')' : '');
}

// Site wide JS goes here
window.onload = (event) => {
  loginForm();
  addressForm();
  formFlow1();
  formFlow2();
};

function loginForm() {
  const groupLogin = document.querySelector("[data-group-login]");
  const forgetButton = document.querySelector("[data-forget-button]");
  const backButton = document.querySelector("[data-login-button]");
  if (groupLogin) {
    if (forgetButton) {
      forgetButton.addEventListener("click", function (e) {
        e.preventDefault();
        groupLogin.classList.add("is-forget");
        groupLogin.classList.remove("is-login");
      });
    }
    if (backButton) {
      backButton.addEventListener("click", function (e) {
        e.preventDefault();
        groupLogin.classList.remove("is-forget");
        groupLogin.classList.add("is-login");
      });
    }
  }
}

function addressForm() {
  const addresses = document.querySelectorAll("[data-address]");
  if (addresses) {
    addresses.forEach((address) => {
      const showButton = address.querySelector("[data-address-show]");
      const closeButton = address.querySelector("[data-address-close]");
      const addressDialog = address.querySelector("[data-address-dialog]");
      showButton.addEventListener("click", (e) => {
        addressDialog.showModal();
      });
      closeButton.addEventListener("click", (e) => {
        addressDialog.close();
      });
    });
  }
  const countrySelectors = document.querySelectorAll(
    "[data-address-country-select]"
  );
  if (countrySelectors) {
    countrySelectors.forEach((countrySelector) => {
      // Set default country and province
      const options = countrySelector.querySelectorAll("option");
      if (options) {
        options.forEach((option) => {
          if (option.value == countrySelector.dataset.default) {
            option.setAttribute("selected", "selected");
          }
        });
      }
      if (
        JSON.parse(
          countrySelector.options[countrySelector.selectedIndex].dataset
            .provinces
        ).length > 0
      ) {
        const provinceWrapper =
          countrySelector.parentElement.parentElement.querySelector(
            "[data-address-province]"
          );
        const provinceSelect =
          countrySelector.parentElement.parentElement.querySelector(
            "[data-address-province-input]"
          );
        provinceSelect.innerHTML = "";
        provinceWrapper.classList.remove("hidden");
        provinceWrapper.classList.add("flex");

        JSON.parse(
          countrySelector.options[countrySelector.selectedIndex].dataset
            .provinces
        ).forEach((province) => {
          const provinceOption = document.createElement("option");
          provinceOption.value = province[0];
          provinceOption.innerHTML = province[1];
          if (provinceOption.value == provinceSelect.dataset.default) {
            provinceOption.setAttribute("selected", "selected");
          }
          provinceSelect.appendChild(provinceOption);
        });
      }

      // Update province selector when country changes
      countrySelector.addEventListener("change", (e) => {
        const provinceArray = JSON.parse(
          e.target.options[e.target.selectedIndex].dataset.provinces
        );
        const provinceSelector =
          e.target.parentElement.parentElement.querySelector(
            "[data-address-province]"
          );
        const provinceInput =
          e.target.parentElement.parentElement.querySelector(
            "[data-address-province-input]"
          );
        //console.log(provinceArray.length);
        if (provinceArray.length > 0) {
          provinceInput.innerHTML = "";
          provinceSelector.classList.remove("hidden");
          provinceSelector.classList.add("flex");
          provinceArray.forEach((province) => {
            const option = document.createElement("option");
            option.value = province[0];
            option.innerHTML = province[1];
            provinceInput.appendChild(option);
          });
        } else {
          provinceSelector.classList.add("hidden");
          provinceSelector.classList.remove("flex");
        }
      });
    });
  }
}

function formFlow1() {
  const flowForm1 = document.querySelector(".flow-1");
  if (!flowForm1) {
    return;
  }

  const customerCheckRadios = flowForm1.querySelectorAll(
    "[data-customer-check]"
  );
  const customerContent = flowForm1.querySelector(
    ".flow-step-content-customer"
  );
  if (customerCheckRadios && customerContent) {
    customerCheckRadios.forEach((customerCheckRadio) => {
      customerCheckRadio.addEventListener("change", function (e) {
        const customerCheck = e.currentTarget;
        // console.log(customerCheck.value);
        if (customerCheck.value === "Yes") {
          customerContent.classList.remove("is-new-customer");
          customerContent.classList.add("is-old-customer");
        } else {
          customerContent.classList.remove("is-old-customer");
          customerContent.classList.add("is-new-customer");
        }
      });
    });
  }

  const radioInsurance = flowForm1.querySelectorAll("[data-insurance-check]");
  if (radioInsurance) {
    radioInsurance.forEach((insuraceRadio) => {
      insuraceRadio.addEventListener("change", function (e) {
        const insuranceCheck = e.currentTarget;
        // console.log(insuranceCheck.value);
        const buttonInsuranceYes = flowForm1.querySelector(".insurance-yes");
        const buttonInsuranceNo = flowForm1.querySelector(".insurance-no");
        if (buttonInsuranceYes && buttonInsuranceNo) {
          if (insuranceCheck.value === "yes") {
            buttonInsuranceYes.classList.remove("is-hidden");
            buttonInsuranceNo.classList.add("is-hidden");
          } else {
            buttonInsuranceYes.classList.add("is-hidden");
            buttonInsuranceNo.classList.remove("is-hidden");
          }
        }
      });
    });
  }

  const buttonInsurance = flowForm1.querySelectorAll("[data-button-insurance]");
  if (buttonInsurance) {
    buttonInsurance.forEach((buttonInsuranceItem) => {
      buttonInsuranceItem.addEventListener("click", function (e) {
        e.preventDefault();
        const insuranceContent = flowForm1.querySelector(
          ".flow-step-content-insurance"
        );
        const customerContent = flowForm1.querySelector(
          ".flow-step-content-customer"
        );
        if (insuranceContent && customerContent) {
          if (e.currentTarget.dataset.buttonInsurance === "show") {
            insuranceContent.classList.remove("is-hidden");
            customerContent.classList.add("is-hidden");
          } else {
            insuranceContent.classList.add("is-hidden");
            customerContent.classList.remove("is-hidden");
          }
        }
      });
    });
  }

  const buttonCarSelector = flowForm1.querySelector(
    "[data-button-car-selector]"
  );
  const carSelector = flowForm1.querySelector("[data-car-selector]");
  const buttonBackSearch = flowForm1.querySelectorAll(
    "[data-button-back-search]"
  );
  if (buttonCarSelector && carSelector && buttonBackSearch) {
    buttonCarSelector.addEventListener("click", function (e) {
      e.preventDefault();
      carSelector.dataset.carSelector = "selector";
    });

    buttonBackSearch.forEach((buttonBackSearchItem) => {
      buttonBackSearchItem.addEventListener("click", function (e) {
        e.preventDefault();
        carSelector.dataset.carSelector = "search";
      });
    });
  }

  // Add event listeners to update the UI when checkboxes change
  const step1Checkboxes = flowForm1.querySelectorAll("[data-insurance-policy]");
  step1Checkboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      // Find the flow-input-wrapper that should be toggled when policy checkboxes are checked
      const step1CheckboxesWrapper = flowForm1.querySelector(
        ".flow-input-wrapper.hide-new-customer"
      );

      // Check if Car checkbox is checked
      const carCheckboxChecked = Array.from(step1Checkboxes).some(
        (checkbox) => checkbox.checked && checkbox.value === "Car"
      );

      // Check if any of Home, Contents, Others checkboxes are checked
      const otherCheckboxesChecked = Array.from(step1Checkboxes).some(
        (checkbox) =>
          checkbox.checked &&
          (checkbox.value === "Home" ||
            checkbox.value === "Contents" ||
            checkbox.value === "Others")
      );

      // Update classes based on checked states
      if (carCheckboxChecked) {
        // If Car is checked, prioritize show-car class
        step1CheckboxesWrapper.classList.add("show-car");
        step1CheckboxesWrapper.classList.remove("show-others");
      } else if (otherCheckboxesChecked) {
        // If Car is not checked but any other checkbox is checked
        step1CheckboxesWrapper.classList.remove("show-car");
        step1CheckboxesWrapper.classList.add("show-others");
      } else {
        // If no checkboxes are checked, remove both classes
        step1CheckboxesWrapper.classList.remove("show-car", "show-others");
      }
    });
  });

  const stepButtons = flowForm1.querySelectorAll("[data-button-step]");
  if (stepButtons) {
    stepButtons.forEach((stepButton) => {
      stepButton.addEventListener("click", function (e) {
        e.preventDefault();
        const stepButton = e.currentTarget;
        const step = stepButton.dataset.buttonStep;
        let isEmpty = false;
        if (step === "2") {
          const customerRadio = flowForm1.querySelector(
            'input[name="existing-customer"]:checked'
          );
          const policyCheckboxes = flowForm1.querySelectorAll(
            "[data-insurance-policy]"
          );
          const anyChecked = Array.from(policyCheckboxes).some(
            (checkbox) => checkbox.checked
          );

          const checkboxMessage = flowForm1.querySelector(
            ".flow-input-checkbox-list-message"
          );

          if (customerRadio.value === "Yes" && !anyChecked) {
            isEmpty = true;
            checkboxMessage.classList.add("is-show");
          } else {
            isEmpty = false;
            checkboxMessage.classList.remove("is-show");
          }
        } else if (step === "3") {
          isEmpty = true;
          const customerInput = flowForm1.querySelectorAll(
            "[data-customer-input]"
          );
          if (customerInput) {
            customerInput.forEach((input) => {
              if (input.value === "") {
                input.classList.add("is-danger");
              } else {
                input.classList.remove("is-danger");
              }
            });

            const firstName = flowForm1.querySelector("#dirver-first-name");
            const lastName = flowForm1.querySelector("#dirver-last-name");
            const dob = flowForm1.querySelector("#dirver-dob");

            if (
              firstName.value === "" ||
              lastName.value === "" ||
              dob.value === ""
            ) {
              isEmpty = true;
            } else {
              isEmpty = false;
            }
          }
        } else if (step === "4") {
          const carreg = flowForm1.querySelector("#car-reg-no-2");
          const carmake = flowForm1.querySelector("#car-make");
          const carmodel = flowForm1.querySelector("#car-model");
          const caryear = flowForm1.querySelector("#car-year");

          if (detailsCheck) {
            const detailsInputCheck = document.querySelector(
              "#car-search-result:checked"
            );
            const detailsInputWrapper =
              document.querySelector("#car-result-box");
            if (detailsInputWrapper) {
              if (detailsInputCheck != null) {
                detailsCheck = false;
              } else {
                detailsCheck = true;
                detailsInputWrapper.classList.add("is-danger");
              }
            }
          }

          if (
            carreg.value === "" ||
            carmake.value === "" ||
            carmodel.value === "" ||
            caryear.value === ""
          ) {
            isEmpty = true;
            if (carreg.value === "") {
              carreg.classList.add("is-danger");
              flowForm1.querySelector("#car-reg-no").classList.add("is-danger");
            } else {
              carreg.classList.remove("is-danger");
              document
                .getElementById("car-reg-no")
                .classList.remove("is-danger");
            }
            if (carmake.value === "") {
              carmake.classList.add("is-danger");
            } else {
              carmake.classList.remove("is-danger");
            }
            if (carmodel.value === "") {
              carmodel.classList.add("is-danger");
            } else {
              carmodel.classList.remove("is-danger");
            }
            if (caryear.value === "") {
              caryear.classList.add("is-danger");
            } else {
              caryear.classList.remove("is-danger");
            }
          } else {
            isEmpty = false;
            carreg.classList.remove("is-danger");
            flowForm1
              .querySelector("#car-reg-no")
              .classList.remove("is-danger");
            carmake.classList.remove("is-danger");
            carmodel.classList.remove("is-danger");
            caryear.classList.remove("is-danger");
          }
        } else {
          isEmpty = false;
        }
        if (!isEmpty && !detailsCheck) {
          // Fire tracking events for each step transition
          const suffix = getProductEventSuffix(document);
          if (step === "2") {
            // Step 1 → Step 2: User starts providing personal details
            // No Floodlight for package/premier_package products
            fireTrackingEvent('ami_rr_start' + suffix, null, {
              eventName: 'Lead',
              params: { content_name: 'ami_rr_start' + suffix }
            });
          } else if (step === "3") {
            // Step 2 → Step 3: User starts providing vehicle details
            fireTrackingEvent('ami_rr_your_details_complete' + suffix, null, {
              eventName: 'Contact',
              params: { content_name: 'ami_rr_your_details_complete' + suffix }
            });
          } else if (step === "4") {
            // Step 3 → Step 4: User views terms and conditions
            fireTrackingEvent('ami_rr_vehicle_details_complete' + suffix, null, {
              eventName: 'SubmitApplication',
              params: { content_name: 'ami_rr_vehicle_details_complete' + suffix }
            });
          }
          
          const stepContents = flowForm1.querySelectorAll("[data-step]");
          if (stepContents) {
            stepContents.forEach((stepContent) => {
              if (stepContent.dataset.step === step) {
                stepContent.classList.remove("is-hidden");
              } else {
                stepContent.classList.add("is-hidden");
              }
            });
          }

          const flowNavActive = flowForm1.querySelector(".flow-step-active");
          const flowNavFinal = flowForm1.querySelector(".flow-step-final");
          if (flowNavActive && flowNavFinal) {
            if (stepButton.dataset.buttonStep === "1") {
              gsap.to(flowNavActive, {
                left: "0%",
                rotate: "0deg",
                duration: 0.5,
                ease: "power4",
              });
              gsap.set(flowNavFinal, {
                left: "100%",
              });
              flowNavFinal.classList.add("is-hidden");
            } else if (stepButton.dataset.buttonStep === "2") {
              gsap.to(flowNavActive, {
                left: "33.333333%",
                rotate: "0deg",
                duration: 0.5,
                ease: "power4",
              });
              gsap.set(flowNavFinal, {
                left: "100%",
              });
              flowNavFinal.classList.add("is-hidden");
            } else if (stepButton.dataset.buttonStep === "3") {
              gsap.to(flowNavActive, {
                left: "66.666666%",
                rotate: "0deg",
                duration: 0.5,
                ease: "power4",
              });
              gsap.set(flowNavFinal, {
                left: "100%",
              });
              flowNavFinal.classList.add("is-hidden");
            } else {
              gsap.set(flowNavFinal, {
                left: "100%",
              });
              gsap.to(flowNavActive, {
                left: "100%",
                rotate: "-5deg",
                duration: 0.5,
                ease: "power4",
                onComplete: function () {
                  flowNavFinal.classList.remove("is-hidden");
                },
              });
            }

            const buttonAccept = flowForm1.querySelector(
              "[data-button-accept]"
            );
            if (buttonAccept) {
              buttonAccept.addEventListener("click", function (e) {
                e.preventDefault();
                e.currentTarget.classList.add("is-loading");
                if (flowNavActive && flowNavFinal) {
                  gsap.to(flowNavActive, {
                    left: "450%",
                    duration: 3,
                    ease: "power2",
                  });

                  gsap.to(flowNavFinal, {
                    left: "500%",
                    duration: 3,
                    ease: "power2",
                  });
                }
              });
            }
          }
        }
      });
    });
  }

  const acceptButton = flowForm1.querySelector("[data-button-accept]");
  if (acceptButton) {
    acceptButton.addEventListener("click", function (e) {
      e.preventDefault();

      // Fire tracking event when user accepts terms and proceeds to checkout
      const suffix = getProductEventSuffix(flowForm1);
      fireTrackingEvent('ami_rr_terms_accepted' + suffix, null, {
        eventName: 'InitiateCheckout',
        params: { content_name: 'ami_rr_terms_accepted' + suffix }
      });

      // Clearing cart items.
      fetch("/cart/clear.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          // console.log("Clear Success:", data);

          const customerCheckRadios = flowForm1.querySelectorAll(
            "[data-customer-check]"
          );

          const selectedRadio = flowForm1.querySelector(
            'input[name="existing-customer"]:checked'
          );
          let product = selectedRadio.dataset.product;
          let sellingPlan = selectedRadio.dataset.sellingPlan;

          if (customerCheckRadios) {
            customerCheckRadios.forEach((customerCheckRadio) => {
              if (customerCheckRadio.checked) {
                const customerCheck = customerCheckRadio.value;
                if (customerCheck === "Yes") {
                  product = customerCheckRadio.dataset.product;
                  sellingPlan = customerCheckRadio.dataset.sellingPlan;

                  // console.log(product, sellingPlan);
                }
              }
            });
          }

          const insuracePoliciesCheckbox = flowForm1.querySelectorAll(
            "[data-insurance-policy]"
          );
          const insuracePolicy = [];
          if (insuracePoliciesCheckbox) {
            insuracePoliciesCheckbox.forEach((insuracePolicyCheckbox) => {
              if (insuracePolicyCheckbox.checked) {
                insuracePolicy.push(insuracePolicyCheckbox.value);
              }
            });
          }
          


          var data = {
            items: [
              {
                id: product,
                selling_plan: sellingPlan,
                quantity: 1,
                properties: {
                  "Driver First Name":
                    flowForm1.querySelector("#dirver-first-name").value,
                  "Driver Last Name":
                    flowForm1.querySelector("#dirver-last-name").value,
                  "Driver DOB": flowForm1.querySelector("#dirver-dob").value,
                  "Car Reg No": flowForm1.querySelector("#car-reg-no").value,
                  "Car Make": flowForm1.querySelector("#car-make").value,
                  "Car Model": flowForm1.querySelector("#car-model").value,
                  "Car Year": flowForm1.querySelector("#car-year").value
                },
              },
            ],
          };

          if (selectedRadio.value === "Yes") {
            data.items[0].properties["Existing Customer"] = selectedRadio.value;
            if (insuracePolicy.length > 0) {
              data.items[0].properties["Insurance Policies"] =
                insuracePolicy.join(", ");
            }
          }
          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          })
            .then((response) => response.json())
            .then((data) => {
              window.location.href = "/checkout";
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        })
        .catch((error) => {
          // Handle any errors here
          console.error("Clear Error:", error);
        });
    });
  }

  const tocModal = document.querySelector("[data-toc-modal]");
  const tocButton = document.querySelector("[data-toc-button]");
  const tocClose = document.querySelector("[data-toc-close]");

  if (tocButton && tocModal && tocClose) {
    tocButton.addEventListener("click", function (e) {
      e.preventDefault();
      if (tocModal.classList.contains("hidden")) {
        tocModal.classList.remove("hidden");
      } else {
        tocModal.classList.add("hidden");
      }
    });

    tocClose.addEventListener("click", function (e) {
      e.preventDefault();
      if (tocModal.classList.contains("hidden")) {
        tocModal.classList.remove("hidden");
      } else {
        tocModal.classList.add("hidden");
      }
    });
  }
}

function formFlow2() {
  const flowForm2 = document.querySelector(".flow-2");
  if (!flowForm2) {
    return;
  }

  const customerCheckRadios = flowForm2.querySelectorAll(
    "[data-customer-check]"
  );
  const customerContent = flowForm2.querySelector(
    ".flow-step-content-customer"
  );
  if (customerCheckRadios && customerContent) {
    customerCheckRadios.forEach((customerCheckRadio) => {
      customerCheckRadio.addEventListener("change", function (e) {
        const customerCheck = e.currentTarget;
        // console.log(customerCheck.value);
        if (customerCheck.value === "Yes") {
          customerContent.classList.remove("is-new-customer");
          customerContent.classList.add("is-old-customer");
        } else {
          customerContent.classList.remove("is-old-customer");
          customerContent.classList.add("is-new-customer");
        }
      });
    });
  }

  const radioInsurance = flowForm2.querySelectorAll("[data-insurance-check]");
  if (radioInsurance) {
    radioInsurance.forEach((insuraceRadio) => {
      insuraceRadio.addEventListener("change", function (e) {
        const insuranceCheck = e.currentTarget;

        const buttonInsuranceYes = flowForm2.querySelector(".insurance-yes");
        const buttonInsuranceNo = flowForm2.querySelector(".insurance-no");
        if (buttonInsuranceYes && buttonInsuranceNo) {
          if (insuranceCheck.value === "yes") {
            buttonInsuranceYes.classList.remove("is-hidden");
            buttonInsuranceNo.classList.add("is-hidden");
          } else {
            buttonInsuranceYes.classList.add("is-hidden");
            buttonInsuranceNo.classList.remove("is-hidden");
          }
        }
      });
    });
  }

  const buttonInsurance = flowForm2.querySelectorAll("[data-button-insurance]");
  if (buttonInsurance) {
    buttonInsurance.forEach((buttonInsuranceItem) => {
      buttonInsuranceItem.addEventListener("click", function (e) {
        e.preventDefault();
        const insuranceContent = document.querySelector(
          ".flow-step-content-insurance"
        );
        const customerContent = document.querySelector(
          ".flow-step-content-customer"
        );
        if (insuranceContent && customerContent) {
          if (e.currentTarget.dataset.buttonInsurance === "show") {
            insuranceContent.classList.remove("is-hidden");
            customerContent.classList.add("is-hidden");
          } else {
            insuranceContent.classList.add("is-hidden");
            customerContent.classList.remove("is-hidden");
          }
        }
      });
    });
  }

  const buttonCarSelector = flowForm2.querySelector(
    "[data-button-car-selector]"
  );
  const carSelector = flowForm2.querySelector("[data-car-selector]");
  const buttonBackSearch = flowForm2.querySelector("[data-button-back-search]");
  if (buttonCarSelector && carSelector) {
    buttonCarSelector.addEventListener("click", function (e) {
      e.preventDefault();
      carSelector.dataset.carSelector = "selector";
    });

    buttonBackSearch.addEventListener("click", function (e) {
      e.preventDefault();
      carSelector.dataset.carSelector = "search";
    });
  }

  const stepButtons = flowForm2.querySelectorAll("[data-button-step]");
  if (stepButtons) {
    stepButtons.forEach((stepButton) => {
      stepButton.addEventListener("click", function (e) {
        e.preventDefault();
        const stepButton = e.currentTarget;
        const step = stepButton.dataset.buttonStep;
        let isEmpty = false;
        const licenseCheck = true;
        if (step === "2") {
          const customerRadio = document.querySelector(
            'input[name="existing-customer"]:checked'
          );
          if (customerRadio.value === "No") {
            window.location.href = customerRadio.dataset.url;
            return;
          }
        } else if (step === "3") {
          isEmpty = true;
          const customerInput = document.querySelectorAll(
            "[data-customer-input]"
          );
          if (customerInput) {
            const inputs = [];
            const firstName = flowForm2.querySelector("#dirver-first-name");
            inputs.push(firstName);
            const lastName = flowForm2.querySelector("#dirver-last-name");
            inputs.push(lastName);
            const dob = flowForm2.querySelector("#dirver-dob");
            inputs.push(dob);

            inputs.forEach((input) => {
              if (input.value === "") {
                input.classList.add("is-danger");
              } else {
                input.classList.remove("is-danger");
              }
            });

            if (
              firstName.value === "" ||
              lastName.value === "" ||
              dob.value === ""
            ) {
              isEmpty = true;
            } else {
              isEmpty = false;
            }
          }
        } else if (step === "4") {
          const inputs2 = [];
          const lnumber = flowForm2.querySelector("#driver-license-number");
          inputs2.push(lnumber);
          const ldoi = flowForm2.querySelector("#license-doi");
          inputs2.push(ldoi);

          inputs2.forEach((input) => {
            if (input.value === "") {
              input.classList.add("is-danger");
            } else {
              input.classList.remove("is-danger");
            }
          });

          if (lnumber.value === "" || ldoi.value === "") {
            isEmpty = true;
          } else {
            isEmpty = false;
          }
        } else {
          isEmpty = false;
        }

        if (!isEmpty) {
          // Fire tracking events for each step transition
          // formFlow2 handles KiwiDriver (Free) product
          // NOTE: Floodlight fires on landing page button click (kiwi-driver-layout.js), not here
          if (step === "2") {
            // Step 1 → Step 2: User starts providing personal details
            fireTrackingEvent('ami_rr_nz_license_12_months_complete_free', null, {
              eventName: 'Lead',
              params: { content_name: 'ami_rr_nz_license_12_months_complete_free' }
            });
          } else if (step === "3") {
            // Step 2 → Step 3: User starts providing licence and vehicle details
            fireTrackingEvent('ami_rr_drivers_details_complete_free', null, {
              eventName: 'Contact',
              params: { content_name: 'ami_rr_drivers_details_complete_free' }
            });
          } else if (step === "4") {
            // Step 3 → Step 4: User views terms and conditions
            fireTrackingEvent('ami_rr_vehicle_details_complete_free', null, {
              eventName: 'SubmitApplication',
              params: { content_name: 'ami_rr_vehicle_details_complete_free' }
            });
          }
          
          const stepContents = flowForm2.querySelectorAll("[data-step]");
          if (stepContents) {
            stepContents.forEach((stepContent) => {
              if (stepContent.dataset.step === step) {
                stepContent.classList.remove("is-hidden");
              } else {
                stepContent.classList.add("is-hidden");
              }
            });
          }

          const flowNavActive = flowForm2.querySelector(".flow-step-active");
          const flowNavFinal = flowForm2.querySelector(".flow-step-final");
          if (flowNavActive && flowNavFinal) {
            if (stepButton.dataset.buttonStep === "1") {
              gsap.to(flowNavActive, {
                left: "0%",
                rotate: "0deg",
                duration: 0.5,
                ease: "power4",
              });
              gsap.set(flowNavFinal, {
                left: "100%",
              });
              flowNavFinal.classList.add("is-hidden");
            } else if (stepButton.dataset.buttonStep === "2") {
              gsap.to(flowNavActive, {
                left: "33.333333%",
                rotate: "0deg",
                duration: 0.5,
                ease: "power4",
              });
              gsap.set(flowNavFinal, {
                left: "100%",
              });
              flowNavFinal.classList.add("is-hidden");
            } else if (stepButton.dataset.buttonStep === "3") {
              gsap.to(flowNavActive, {
                left: "66.666666%",
                rotate: "0deg",
                duration: 0.5,
                ease: "power4",
              });
              gsap.set(flowNavFinal, {
                left: "100%",
              });
              flowNavFinal.classList.add("is-hidden");
            } else {
              gsap.set(flowNavFinal, {
                left: "100%",
              });
              gsap.to(flowNavActive, {
                left: "100%",
                rotate: "-5deg",
                duration: 0.5,
                ease: "power4",
                onComplete: function () {
                  flowNavFinal.classList.remove("is-hidden");
                },
              });
            }

            const buttonAccept = flowForm2.querySelector(
              "[data-button-accept]"
            );
            if (buttonAccept) {
              buttonAccept.addEventListener("click", function (e) {
                e.preventDefault();
                e.currentTarget.classList.add("is-loading");
                if (flowNavActive && flowNavFinal) {
                  gsap.to(flowNavActive, {
                    left: "450%",
                    duration: 3,
                    ease: "power2",
                  });

                  gsap.to(flowNavFinal, {
                    left: "500%",
                    duration: 3,
                    ease: "power2",
                  });
                }
              });
            }
          }
        }
      });
    });
  }

  const acceptButton = flowForm2.querySelector("[data-button-accept]");
  if (acceptButton) {
    acceptButton.addEventListener("click", function (e) {
      e.preventDefault();

      // Fire tracking event when user accepts terms and proceeds to checkout
      fireTrackingEvent('ami_rr_terms_accepted_free', null, {
        eventName: 'InitiateCheckout',
        params: { content_name: 'ami_rr_terms_accepted_free' }
      });

      // Clearing cart items.
      fetch("/cart/clear.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          // console.log("Clear Success:", data);

          const customerCheckRadios = flowForm2.querySelectorAll(
            "[data-customer-check]"
          );

          const selectedRadio = flowForm2.querySelector(
            'input[name="existing-customer"]:checked'
          );
          let product = selectedRadio.dataset.product;
          let sellingPlan = selectedRadio.dataset.sellingPlan;

          if (customerCheckRadios) {
            customerCheckRadios.forEach((customerCheckRadio) => {
              if (customerCheckRadio.checked) {
                const customerCheck = customerCheckRadio.value;
                if (customerCheck === "Yes") {
                  product = customerCheckRadio.dataset.product;
                  sellingPlan = customerCheckRadio.dataset.sellingPlan;

                  // console.log(product, sellingPlan);
                }
              }
            });
          }

          const insuracePoliciesCheckbox = document.querySelectorAll(
            "[data-insurance-policy]"
          );
          const insuracePolicy = [];
          if (insuracePoliciesCheckbox) {
            insuracePoliciesCheckbox.forEach((insuracePolicyCheckbox) => {
              if (insuracePolicyCheckbox.checked) {
                insuracePolicy.push(insuracePolicyCheckbox.value);
              }
            });
          }
          
          const licenseNumber = flowForm2.querySelector(
            "#driver-license-number"
          ).value;
          let licenseNumberStart = "";
          let licenseNumberEnd = "";
          if (licenseNumber) {
            if (licenseNumber.length > 2){
              licenseNumberStart = licenseNumber.slice(0, 2)
              licenseNumberEnd = licenseNumber.slice(-2);
            }
          }

          var data = {
            items: [
              {
                id: product,
                selling_plan: sellingPlan,
                quantity: 1,
                properties: {
                  "Driver First Name":
                    flowForm2.querySelector("#dirver-first-name").value,
                  "Driver Last Name":
                    flowForm2.querySelector("#dirver-last-name").value,
                  "Date of birth": flowForm2.querySelector("#dirver-dob").value,
                  "License start": licenseNumberStart,
                  "License end": licenseNumberEnd,
                  "License date of issue":
                    flowForm2.querySelector("#license-doi").value,
                  "Car Reg No": flowForm2.querySelector("#car-reg-no-2").value,
                  "Car Make": flowForm2.querySelector("#car-make").value,
                  "Car Model": flowForm2.querySelector("#car-model").value,
                  "Car Year": flowForm2.querySelector("#car-year").value,
                },
              },
            ],
          };

          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          })
            .then((response) => response.json())
            .then((data) => {
              window.location.href = "/checkout";
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        })
        .catch((error) => {
          // Handle any errors here
          console.error("Clear Error:", error);
        });
    });
  }

  const tocModal = document.querySelector("[data-toc-modal]");
  const tocButton = document.querySelector("[data-toc-button]");
  const tocClose = document.querySelector("[data-toc-close]");

  if (tocButton && tocModal && tocClose) {
    tocButton.addEventListener("click", function (e) {
      e.preventDefault();
      if (tocModal.classList.contains("hidden")) {
        tocModal.classList.remove("hidden");
      } else {
        tocModal.classList.add("hidden");
      }
    });

    tocClose.addEventListener("click", function (e) {
      e.preventDefault();
      if (tocModal.classList.contains("hidden")) {
        tocModal.classList.remove("hidden");
      } else {
        tocModal.classList.add("hidden");
      }
    });
  }
}

function getCarDetails(target) {
  const searchInput = document.getElementById("car-reg-no");
  document.getElementById("car-invalid-message").style.display = "none";

  var value = document.getElementById("car-reg-no").value.toUpperCase();
  if (value !== "") {
    searchInput.classList.remove("is-danger");
    target.classList.add("is-loading");
  } else {
    searchInput.classList.add("is-danger");
  }
  // console.log(value);
  var data = {
    plate_no: value,
  };
  var body_style = {
    AT: "Articulated Truck",
    CC: "Cab-Chassis only",
    CV: "Convertible",
    FT: "Flat Deck Truck",
    HA: "Hatchback",
    HB: "Heavy Bus/Service Coach",
    HV: "Heavy Van",
    LB: "Minibus",
    LV: "Light Van",
    MC: "Motorcycle",
    MM: "Mobile Machine",
    OR: "Off Road",
    OT: "Other Truck",
    SC: "Self Propelled Caravan",
    SL: "Saloon",
    SP: "Sports Car",
    SW: "Station Wagon",
    TA: "Tractor",
    TB: "Boat Trailer",
    TC: "Caravan",
    TD: "Domestic Trailer",
    TF: "Flat Deck Trailer",
    TO: "Other Commercial Trailer",
    UT: "Utility",
    XX: "Unknown",
  };
  var fuel_type = {
    0: null,
    1: "Petrol",
    2: "Diesel",
    3: "CNG",
    4: "LPG",
    5: "Electric",
    6: "Other",
    7: "Petrol Hybrid",
    8: "Diesel Hybrid",
    9: "Petrol Electric Hybrid",
    10: "Diesel Electric Hybrid",
    11: "Plug-in Petrol Hybrid",
    12: "Plug-in Diesel Hybrid",
    13: "Electric - Petrol Extended",
    14: "Electric - Diesel Extended",
    15: "Electric Fuel Cell Hydrogen",
    16: "Electric Fuel Cell Other",
    17: "Plug-in Fuel Cell Hydrogen Hybrid",
    18: "Plug-in Fuel Cell Other Hybrid",
    91: "Petrol Hybrid",
    92: "Plug-in Hybrid-Petrol",
    93: "Hybrid",
    94: "Diesel Hybrid",
    95: "Electric Hybrid",
    96: "Plug-in Hybrid-Diesel",
    97: "Electric (fuel cell)",
  };
  if (value.length >= 1 && value.length <= 8) {
    fetch("/apps/vehicle_rego?plate=" + value, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        target.classList.remove("is-loading");

        if (data != null && typeof data.error == "undefined") {
          // console.log(data);

          if (
            data[0].class != "MA" &&
            data[0].class != "MB" &&
            data[0].class != "MC" &&
            data[0].class != "MD1" &&
            data[0].class != "MD2" &&
            data[0].class != "NA"
          ) {
            document.getElementById("car-result-header").style.display = "none";
            document.getElementById("car-result-box").style.display = "none";
            document.getElementById("car-invalid-message").style.display =
              "block";

            document.getElementById(
              "search-continue-button"
            ).style.backgroundColor = "grey";

            document.getElementById("car-selector-error").style.display =
              "none";
            const buttonCarSelector = document.querySelector(
              "[data-button-car-selector]"
            );
            const carSelector = document.querySelector("[data-car-selector]");
            buttonCarSelector.addEventListener("click", function (e) {
              e.preventDefault();
              carSelector.dataset.carSelector = "selector";
            });

            document.getElementById("car-reg-no-2").value = "";
            document.getElementById("car-make").value = "";
            document.getElementById("car-model").value = "";
            document.getElementById("car-year").value = "";
          } else {
            let fuelTypeClean = data[0].fuel_type.replace(/^0+/, "");
            document.getElementById("car-selector-error").style.display =
              "block";
            var carString = "";
            if (data[0].make != null) {
              carString = carString + data[0].make;
            }
            if (data[0].model != null) {
              carString = carString + ", " + data[0].model;
            }
            if (data[0].year_of_manufacture != null) {
              carString = carString + ", " + data[0].year_of_manufacture;
            }
            if (data[0].body_style != null) {
              carString = carString + ", " + body_style[data[0].body_style];
            }
            if (data[0].submodel != null) {
              carString = carString + ", " + data[0].submodel;
            }
            if (data[0].transmission != null) {
              carString = carString + ", " + data[0].transmission;
            }
            if (data[0].drive != null) {
              carString = carString + ", " + data[0].drive;
            }
            if (data[0].cc_rating != null) {
              carString = carString + ", " + data[0].cc_rating + "cc";
            }
            if (data[0].fuel_type != null) {
              carString = carString + ", " + fuel_type[fuelTypeClean];
            }
            if (data[0].no_of_doors != null) {
              carString = carString + ", " + data[0].no_of_doors + "dr";
            }

            document.getElementById(
              "search-continue-button"
            ).style.backgroundColor = "#008275";

            document.getElementById("car-result-header").style.display =
              "block";
            document.getElementById("car-result-box").style.display = "flex";
            document.getElementById("car-selector-error").innerHTML =
              "Don't know your registration? <a href='#' data-button-car-selector>None of these options match your vehicle</a>";
            const buttonCarSelector = document.querySelector(
              "[data-button-car-selector]"
            );
            const carSelector = document.querySelector("[data-car-selector]");
            buttonCarSelector.addEventListener("click", function (e) {
              e.preventDefault();
              carSelector.dataset.carSelector = "selector";
            });
            document.getElementById("car-search-result-value").innerHTML =
              carString;
            document.getElementById("car-reg-no-2").value = value;
            document.getElementById("car-make").value = data[0].make;
            document.getElementById("car-model").value = data[0].model;
            document.getElementById("car-year").value =
              data[0].year_of_manufacture;
            detailsCheck = true;
          }
        } else {
          document.getElementById("car-result-header").style.display = "none";
          document.getElementById("car-result-box").style.display = "none";
          detailsCheck = false;

          document.getElementById(
            "search-continue-button"
          ).style.backgroundColor = "grey";

          document.getElementById("car-selector-error").style.display = "block";
          document.getElementById("car-selector-error").innerHTML =
            "Sorry, we're having trouble with that rego. <a href='#' data-button-car-selector>Please enter your details manually here.</a>";
          const buttonCarSelector = document.querySelector(
            "[data-button-car-selector]"
          );
          const carSelector = document.querySelector("[data-car-selector]");
          buttonCarSelector.addEventListener("click", function (e) {
            e.preventDefault();
            // console.log("click");
            document.getElementById(
              "search-continue-button"
            ).style.backgroundColor = "#008275";
            carSelector.dataset.carSelector = "selector";
          });

          document.getElementById("car-reg-no-2").value = "";
          document.getElementById("car-make").value = "";
          document.getElementById("car-model").value = "";
          document.getElementById("car-year").value = "";
        }
        //$('.loader-wrapper').hide();
        //vehicleValidation();
      })
      .catch((error) => {
        // Handle any errors here
        console.error("Clear Error:", error);
      });
  }
}

// Redirect to checkout if on cart page
if (window.location.pathname === "/cart") {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      if (cart.items.length > 0) {
        window.location.href = "/checkout";
      } else {
        window.location.href = "/";
      }
    })
    .catch((error) => {
      console.error("Error fetching cart:", error);
    });
}
